import { stripHtml } from '@/utils';

export function classTourEnabled(store) {
  const pv = store.getters['productVars/get']['masteryTourConfig'];
  return !!pv;
}

export function getClassTourConfig(store) {
  const pv = store.getters['productVars/get']['masteryTourConfig'];
  const config = pv && JSON.parse(pv.value);
  const classification = store.getters['session/userClass'];
  if (typeof config === 'object') {
    return config[classification];
  }
}

export function standardTourEnabled(store) {
  const productVars = store.getters['productVars/get'];
  const pv = !!productVars['onboardingCategory'];
  const questionnaire = !!productVars['onboardingQuestionnaire'];
  return pv && !questionnaire;
}

export function getTourType(store) {
  if (classTourEnabled(store)) {
    let type = getClassTourConfig(store).type;
    if (type === 'topic_bookmarks') {
      return 'bookmark';
    } else {
      return type;
    }
  } else if (standardTourEnabled(store)) {
    return 'questions';
  }
}

export function scheduleTour(store) {
  if (classTourEnabled(store) || standardTourEnabled(store)) {
    store.commit('session/scheduleTour', true);
  }
}

// this function requires context to be applied
export function startTour() {
  this.$store.commit('session/scheduleTour', false);
  if (standardTourEnabled(this.$store)) {
    const pv = this.$store.getters['productVars/get']['onboardingCategory'];
    const categoryId = pv.value;
    this.$analytics.events.startedOnboardingCategory(categoryId);
    this.$modal.hide('questions-start-tour-modal');
    startQuestionsTour.apply(this, [categoryId]);
  } else if (classTourEnabled(this.$store)) {
    const config = getClassTourConfig(this.$store);
    const type = getTourType(this.$store);
    if (type === 'questions') {
      this.$analytics.events.startedOnboardingCategory(config.categoryId);
      this.$modal.hide('questions-start-tour-modal');
      startQuestionsTour.apply(this, [config.categoryId]);
    } else if (type === 'bookmark') {
      startBookmarkTour.apply(this);
    }
  }
}

function setDynamicNavItem(resourceId) {
  let lastId = (this.$store.getters['navigationItems/navigationItemsList'].sort((a, b) => a.id - b.id).slice(-1).pop() || {}).id;
  const menuGroupId = (this.$store.getters['navigationGroups/menuNavigationGroup'] || {}).id;
  let item = {
    destination: 'flashcard_categories',
    dynamic: true,
    icon: 'questions',
    id: ++lastId,
    name: 'Onboarding Questions',
    navigationGroupId: menuGroupId,
    order: -1,
    resourceId: resourceId,
  };
  this.$store.commit('navigationItems/setNavigationItems', [item]);
  // get item after query is updated
  item = this.$store.getters['navigationItems/navigationItems'][lastId];
  return item;
}

export function startQuestionsTour(categoryId) {
  const category = this.$store.getters['categories/categories'][categoryId];
  const resourceId = category.categoryTypeId;
  const navItem = setDynamicNavItem.apply(this, [resourceId]);
  this.$store.commit('session/scheduleTour', false);
  this.$store.commit('session/setOnTour', true);
  this.$store.commit('session/setTourType', 'questions');
  this.$store.commit('session/setTourSequence', 1);
  if (this.questionUiV2Enabled) {
    return this.$router.push({ name: 'categories#flashcard-v2', params: { categoryId: category.id }, query: { nav: navItem.query } });
  }
  return this.$router.push({ name: 'categories#flashcard', params: { categoryId: category.id }, query: { nav: navItem.query } });
}

export function startBookmarkTour() {
  this.$store.commit('session/scheduleTour', false);
  this.$store.commit('session/setOnTour', true);
  this.$store.commit('session/setTourType', 'bookmark');
  this.$modal.hide('bookmark-start-tour-modal');
  incrementTourSequence.apply(this, [1]);
}

export function shouldEnterTour(store) {
  if (store.getters['session/tourScheduled']) {
    if (classTourEnabled(store)) {
      return !!getClassTourConfig(store);
    } else if (standardTourEnabled(store)) {
      return true;
    }
  }
}

export function showTourModal() {
  this.$modal.show(`${getTourType(this.$store)}-start-tour-modal`);
}

export function bookmarkTooltips(searchTerm) {
  // default text values are for student_rn currently
  return [
    {
      text: {
        default: `<p><strong>Easily search by keyword or topic.</strong></p><p>Click search above to see the results for "${searchTerm}".</p>`,
      },
      placement: 'bottom',
    },
    {
      text: {
        default: '<p><strong>Choose a result.</strong></p><p>Results are returned sorted by topics.</p><p>Click on the result highlighted above to see more detail.<p>',
        nurse_rn: '<p><strong>Choose a result.</strong></p><p>Results are returned sorted by topics, questions, media, etc.</p><p>Click on the result highlighted above to see more detail.<p>',
      },
      placement: 'bottom-start',
    },
    {
      text: {
        default: '<p><strong>Scroll and read through the content. Notice the ability to expand areas.</strong></p><p>Let’s go ahead and click & bookmark this result next.<p>',
      },
      placement: 'top',
    },
    {
      text: {
        default: '<p><strong>You’ll be able to quickly access your bookmarks.</strong></p><p>Click on ‘bookmarks’ next, please.<p>',
      },
      placement: 'right',
    },
    {
      text: {
        default: '<p><strong>Remember to bookmark topics to study, reference quickly, or read later.</strong></p><p>Click below and explore for areas that can help you master nursing school.<p>',
        nurse_rn: '<p><strong>Remember to bookmark topics to study, reference quickly, or read later.</strong></p><p>Click below and explore for areas that can help you master nursing.<p>',
      },
      placement: 'none',
    },
  ];
}

export function incrementTourSequence(number) {
  this.$store.commit('session/setTourSequence', number);
  const textOptions = bookmarkTooltips('term')[number - 1].text;
  const params = {
    description: 'FTUX',
    stepNumber: number,
    stepText: stripHtml(textOptions[this.$store.getters['session/userClass']] || textOptions.default),
    type: getClassTourConfig(this.$store).type,
  };
  this.$analytics.events.viewedTour(params);
}
